import { Navigate, Outlet } from "react-router-dom";
import { useClinicianAuthStore } from "@/stores/clinicianAuthStore";
import { useClinicianSocket } from "@/lib/clinicianSocket";
import { useIdleLogout } from "@/portals/clinician/hooks/useIdleLogout";
import { PageSpinner } from "@/shared/components/spinner";
import { QueryCacheProvider } from "@/shared/hooks/useCachedQuery";
import { ClinicianLayout } from "./ClinicianLayout";

function SessionLoader() {
  return (
    <div className="bg-white">
      <PageSpinner fullScreen />
    </div>
  );
}

export function ClinicianProtectedLayout() {
  const isAuthenticated = useClinicianAuthStore((s) => s.isAuthenticated);
  const isLoading = useClinicianAuthStore((s) => s.isLoading);
  useIdleLogout();
  useClinicianSocket();

  if (isLoading) return <SessionLoader />;
  if (!isAuthenticated) return <Navigate to="/clinician/login" replace />;

  // Screen-data cache for this session only — unmounted (and emptied) on logout.
  return (
    <QueryCacheProvider>
      <ClinicianLayout>
        <Outlet />
      </ClinicianLayout>
    </QueryCacheProvider>
  );
}
